/**
 * Formats "ballstories®" as superscript across the storefront.
 * SSR uses snippets/bs-trademark.liquid; this script covers dynamic
 * content, Shopify admin pages, and app blocks.
 * Cover/preview titles ("Maxis ballstories") are excluded.
 */
(function () {
  'use strict';

  var MARKER = 'ballstories®';
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, SUP: 1, NOSCRIPT: 1 };
  var SKIP_SELECTOR =
    '.bs-trademark-skip, [data-bs-book-title], .bs-c__book-title, ' +
    '.bs-clubhero__cover-line1, .bs-clubhero__cover-title, .bs-clubhero__header-name, ' +
    '.bs-vereine__cover-line1, .bs-vereine__cover-title, .bs-br__card-cover-line1, .bs-br__section-title';

  function shouldSkipNode(node) {
    var parent = node.parentElement;
    while (parent) {
      if (parent.classList && parent.classList.contains('bs-trademark')) return true;
      if (parent.classList && parent.classList.contains('bs-trademark-skip')) return true;
      if (SKIP_TAGS[parent.tagName]) return true;
      if (parent.matches && parent.matches(SKIP_SELECTOR)) return true;
      parent = parent.parentElement;
    }
    return false;
  }

  function processTextNode(node) {
    if (!node.nodeValue || node.nodeValue.indexOf(MARKER) === -1) return;
    if (shouldSkipNode(node)) return;

    var parts = node.nodeValue.split(MARKER);
    if (parts.length < 2) return;

    var fragment = document.createDocumentFragment();
    parts.forEach(function (part, index) {
      if (index > 0) {
        fragment.appendChild(document.createTextNode('ballstories'));
        var sup = document.createElement('sup');
        sup.className = 'bs-trademark';
        sup.setAttribute('aria-hidden', 'true');
        sup.textContent = '®';
        fragment.appendChild(sup);
      }
      if (part) fragment.appendChild(document.createTextNode(part));
    });

    node.parentNode.replaceChild(fragment, node);
  }

  function walk(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(SKIP_SELECTOR)) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var current;
    while ((current = walker.nextNode())) {
      if (current.nodeValue && current.nodeValue.indexOf(MARKER) !== -1) {
        nodes.push(current);
      }
    }
    nodes.forEach(processTextNode);
  }

  function init() {
    if (document.body) walk(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof MutationObserver !== 'undefined' && document.body) {
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        walk(document.body);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  window.bsFormatTrademarkHtml = function (text) {
    if (!text) return '';
    return String(text).replace(
      /ballstories®/g,
      'ballstories<sup class="bs-trademark" aria-hidden="true">®</sup>'
    );
  };
})();
